export default "__VITE_ASSET__fb9b193b__"